import { useEffect, useState } from "react";

/**
 * useFetch — runs `fetcher(signal)` whenever any value in `deps` changes.
 * Cancels in-flight requests on unmount / re-run.
 *
 * Returns { data, loading, error }.
 */
export default function useFetch(fetcher, deps = []) {
  const [state, setState] = useState({ data: null, loading: true, error: null });

  useEffect(() => {
    const ctrl = new AbortController();
    let cancelled = false;

    setState((s) => ({ ...s, loading: true, error: null }));

    Promise.resolve(fetcher(ctrl.signal))
      .then((data) => {
        if (cancelled) return;
        setState({ data, loading: false, error: null });
      })
      .catch((err) => {
        if (cancelled || err.name === "AbortError") return;
        setState({ data: null, loading: false, error: err });
      });

    return () => {
      cancelled = true;
      ctrl.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return state;
}
